import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=76b58b8f&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./detail.css?vue&type=style&index=0&id=76b58b8f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b58b8f",
  null
  
)

export default component.exports